// Textos de Rotinas da folha (31/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.rotinas.titulo': 'Rotinas da folha',
    'dp.rotinas.aba.rotinas': 'Rotinas',
    'dp.rotinas.aba.checklist': 'Checklist da folha',
    'dp.rotinas.mes': 'Mês',
    'dp.rotinas.competencia': 'Competência {{rotulo}}',
    'dp.rotinas.kpi.vencidas': 'Vencidas',
    'dp.rotinas.kpi.hoje': 'Vencem hoje',
    'dp.rotinas.kpi.proximas': 'Vencem em {{proximoDias}} dias',
    'dp.rotinas.kpi.pendentes': 'Pendentes',
    'dp.rotinas.kpi.feitas': 'Feitas no mês',
    'dp.rotinas.kpi.conferencias': 'Conferências pendentes',
    'dp.rotinas.col.rotina': 'Rotina',
    'dp.rotinas.col.escopo': 'Escopo',
    'dp.rotinas.col.prazo': 'Prazo',
    'dp.rotinas.col.dono': 'Dono',
    'dp.rotinas.busca': 'Buscar atividade, dono ou número',
    'dp.rotinas.dono': 'Dono',
    'dp.rotinas.todosDonos': 'Todos os donos',
    'dp.rotinas.escopo': 'Escopo',
    'dp.rotinas.todosEscopos': 'Todos os escopos',
    'dp.rotinas.gerarMes': 'Gerar mês',
    'dp.rotinas.mesGerado': '{{n}} ocorrências criadas.',
    'dp.rotinas.mesNaoGerado': 'O mês ainda não foi gerado. Gere para ver as rotinas com a data limite de cada uma.',
    'dp.rotinas.catalogo': 'Catálogo',
    'dp.rotinas.marcar': 'Marcar',
    'dp.rotinas.editarRotina': 'Corrigir a rotina',
    'dp.rotinas.situacao.pendente': 'Pendente',
    'dp.rotinas.situacao.feita': 'Feita',
    'dp.rotinas.situacao.nao_se_aplica': 'Não se aplica',
    'dp.rotinas.feitaEm': 'Feita em',
    'dp.rotinas.feitaEmData': 'Feita em {{data}}',
    'dp.rotinas.marcarTitulo': 'Rotina {{numero}}',
    'dp.rotinas.prazo.dia_do_mes': 'Até o dia {{n}}',
    'dp.rotinas.prazo.dia_util': '{{n}}º dia útil',
    'dp.rotinas.prazo.data_anual': 'Todo ano em {{data}}',
    'dp.rotinas.prazo.livre': 'Sem data',
    'dp.rotinas.tipoPrazo': 'Regra do prazo',
    'dp.rotinas.tipoPrazo.dia_do_mes': 'Dia do mês',
    'dp.rotinas.tipoPrazo.dia_util': 'Dia útil',
    'dp.rotinas.tipoPrazo.data_anual': 'Data do ano',
    'dp.rotinas.tipoPrazo.livre': 'Livre, sem data',
    'dp.rotinas.prazoValor.dia': 'Dia do mês, de 1 a 31',
    'dp.rotinas.prazoValor.enesimo': 'Enésimo dia útil',
    'dp.rotinas.prazoValor.data': 'Mês e dia, como 01-15',
    'dp.rotinas.prazoTexto': 'Como a planilha escreve',
    'dp.rotinas.ativa': 'Ativa',
    'dp.rotinas.inativa': 'Desativada',
    'dp.rotinas.foraDoEscopo': 'Fora do escopo',
    'dp.rotinas.pop': 'POP',
    'dp.rotinas.catalogoTitulo': 'Catálogo de rotinas',
    'dp.rotinas.catalogoExplica': 'As rotinas da planilha do DP, com as fora do escopo e as desativadas. Desativar tira a rotina dos meses seguintes. Corrigir o prazo refaz a data das ocorrências pendentes deste mês em diante. A próxima importação da planilha volta a valer sobre prazo e dono.',
    'dp.rotinas.catalogo.filtro': 'Mostrar',
    'dp.rotinas.catalogo.todas': 'Todas',
    'dp.rotinas.catalogo.ativas': 'Ativas',
    'dp.rotinas.catalogo.inativas': 'Desativadas',
    'dp.rotinas.catalogo.foraDoEscopo': 'Fora do escopo',
    'dp.rotinas.catalogo.busca': 'Buscar atividade ou número',
    'dp.rotinas.catalogo.editar': 'Editar',
    'dp.rotinas.catalogo.contagem': '{{n}} de {{total}} rotinas',
    'dp.rotinas.rotinaTitulo': 'Rotina {{numero}}',
    'dp.rotinas.comoFunciona': 'No começo do mês, Gerar mês cria uma ocorrência por rotina ativa dentro do escopo, com a data limite calculada do prazo da rotina, dos feriados do Hub e do sábado como dia útil. Rotina de prazo livre entra sem data. O checklist da folha usa o mesmo mês como competência.',
    'dp.rotinas.checklist.gerar': 'Gerar conferências',
    'dp.rotinas.checklist.naoGerado': 'A competência ainda não tem conferências. Gere para marcar item a item.',
    'dp.rotinas.checklist.gerado': '{{n}} conferências criadas.',
    'dp.rotinas.checklist.conferir': 'Conferir',
    'dp.rotinas.checklist.etapa.antes': 'Antes de rodar a folha',
    'dp.rotinas.checklist.etapa.na_folha': 'Na folha',
    'dp.rotinas.checklist.etapa.depois': 'Depois do pagamento',
    'dp.rotinas.checklist.situacao.pendente': 'Pendente',
    'dp.rotinas.checklist.situacao.conferida': 'Conferida',
    'dp.rotinas.checklist.situacao.com_ressalva': 'Com ressalva',
    'dp.rotinas.checklist.conferidaEm': 'Conferida em',
    'dp.rotinas.checklist.conferidaEmData': 'Conferida em {{data}}',
    'dp.rotinas.checklist.resumo': '{{conferidas}} conferidas, {{ressalvas}} com ressalva e {{pendentes}} pendentes de {{total}}',
    'dp.rotinas.checklist.periodo': 'De {{inicio}} a {{fim}}',
    'dp.rotinas.checklist.chave': 'Chave {{chave}}',
    'dp.rotinas.checklist.inativo': 'Item desativado',
    'dp.rotinas.checklist.vazio': 'Nenhum item importado. Importe a planilha de descrição das atividades.',
    'dp.rotinas.checklist.comoFunciona': 'Cada item do checklist do cálculo da folha, por etapa, com a conferência da competência. A ressalva pede a observação. A chave de cada item é a que a automação vai usar.',
    'dp.rotinas.importarTitulo': 'Importar a descrição das atividades',
    'dp.rotinas.importarExplica': 'A planilha de descrição das atividades do DP, com a aba Detalhamento de Rotinas e a aba do checklist da folha. O catálogo se atualiza pelo número da rotina e pela chave do item, sem apagar o que sumiu da planilha; a rotina desativada no Hub continua desativada.',
    'dp.rotinas.carga.rotinas': 'Rotinas na planilha',
    'dp.rotinas.carga.foraDoEscopo': 'Rotinas fora do escopo',
    'dp.rotinas.carga.prazoLivre': 'Rotinas sem regra de data',
    'dp.rotinas.carga.itens': 'Itens do checklist',
    'dp.rotinas.carga.rotinasAusentes': 'Rotinas do Hub ausentes da planilha',
  },
  en: {
    'dp.rotinas.titulo': 'Payroll routines',
    'dp.rotinas.aba.rotinas': 'Routines',
    'dp.rotinas.aba.checklist': 'Payroll checklist',
    'dp.rotinas.mes': 'Month',
    'dp.rotinas.competencia': 'Period {{rotulo}}',
    'dp.rotinas.kpi.vencidas': 'Overdue',
    'dp.rotinas.kpi.hoje': 'Due today',
    'dp.rotinas.kpi.proximas': 'Due within {{proximoDias}} days',
    'dp.rotinas.kpi.pendentes': 'Pending',
    'dp.rotinas.kpi.feitas': 'Done this month',
    'dp.rotinas.kpi.conferencias': 'Pending checks',
    'dp.rotinas.col.rotina': 'Routine',
    'dp.rotinas.col.escopo': 'Scope',
    'dp.rotinas.col.prazo': 'Deadline',
    'dp.rotinas.col.dono': 'Owner',
    'dp.rotinas.busca': 'Search activity, owner or number',
    'dp.rotinas.dono': 'Owner',
    'dp.rotinas.todosDonos': 'All owners',
    'dp.rotinas.escopo': 'Scope',
    'dp.rotinas.todosEscopos': 'All scopes',
    'dp.rotinas.gerarMes': 'Generate month',
    'dp.rotinas.mesGerado': '{{n}} occurrences created.',
    'dp.rotinas.mesNaoGerado': 'This month has not been generated yet. Generate it to see each routine with its deadline.',
    'dp.rotinas.catalogo': 'Catalog',
    'dp.rotinas.marcar': 'Mark',
    'dp.rotinas.editarRotina': 'Fix the routine',
    'dp.rotinas.situacao.pendente': 'Pending',
    'dp.rotinas.situacao.feita': 'Done',
    'dp.rotinas.situacao.nao_se_aplica': 'Not applicable',
    'dp.rotinas.feitaEm': 'Done on',
    'dp.rotinas.feitaEmData': 'Done on {{data}}',
    'dp.rotinas.marcarTitulo': 'Routine {{numero}}',
    'dp.rotinas.prazo.dia_do_mes': 'By day {{n}}',
    'dp.rotinas.prazo.dia_util': 'Business day {{n}}',
    'dp.rotinas.prazo.data_anual': 'Every year on {{data}}',
    'dp.rotinas.prazo.livre': 'No date',
    'dp.rotinas.tipoPrazo': 'Deadline rule',
    'dp.rotinas.tipoPrazo.dia_do_mes': 'Day of month',
    'dp.rotinas.tipoPrazo.dia_util': 'Business day',
    'dp.rotinas.tipoPrazo.data_anual': 'Yearly date',
    'dp.rotinas.tipoPrazo.livre': 'Free, no date',
    'dp.rotinas.prazoValor.dia': 'Day of month, 1 to 31',
    'dp.rotinas.prazoValor.enesimo': 'Nth business day',
    'dp.rotinas.prazoValor.data': 'Month and day, like 01-15',
    'dp.rotinas.prazoTexto': 'As written in the spreadsheet',
    'dp.rotinas.ativa': 'Active',
    'dp.rotinas.inativa': 'Disabled',
    'dp.rotinas.foraDoEscopo': 'Out of scope',
    'dp.rotinas.pop': 'SOP',
    'dp.rotinas.catalogoTitulo': 'Routine catalog',
    'dp.rotinas.catalogoExplica': 'The routines from the HR spreadsheet, including the ones out of scope and the disabled ones. Disabling removes the routine from the following months. Fixing the deadline recomputes the date of pending occurrences from this month on. The next spreadsheet import takes over deadline and owner again.',
    'dp.rotinas.catalogo.filtro': 'Show',
    'dp.rotinas.catalogo.todas': 'All',
    'dp.rotinas.catalogo.ativas': 'Active',
    'dp.rotinas.catalogo.inativas': 'Disabled',
    'dp.rotinas.catalogo.foraDoEscopo': 'Out of scope',
    'dp.rotinas.catalogo.busca': 'Search activity or number',
    'dp.rotinas.catalogo.editar': 'Edit',
    'dp.rotinas.catalogo.contagem': '{{n}} of {{total}} routines',
    'dp.rotinas.rotinaTitulo': 'Routine {{numero}}',
    'dp.rotinas.comoFunciona': 'At the start of the month, Generate month creates one occurrence per active in-scope routine, with the deadline computed from the routine rule, the Hub holidays and Saturday as a business day. Routines with a free deadline come without a date. The payroll checklist uses the same month as its period.',
    'dp.rotinas.checklist.gerar': 'Generate checks',
    'dp.rotinas.checklist.naoGerado': 'This period has no checks yet. Generate them to mark item by item.',
    'dp.rotinas.checklist.gerado': '{{n}} checks created.',
    'dp.rotinas.checklist.conferir': 'Check',
    'dp.rotinas.checklist.etapa.antes': 'Before running payroll',
    'dp.rotinas.checklist.etapa.na_folha': 'In the payroll',
    'dp.rotinas.checklist.etapa.depois': 'After payment',
    'dp.rotinas.checklist.situacao.pendente': 'Pending',
    'dp.rotinas.checklist.situacao.conferida': 'Checked',
    'dp.rotinas.checklist.situacao.com_ressalva': 'With remarks',
    'dp.rotinas.checklist.conferidaEm': 'Checked on',
    'dp.rotinas.checklist.conferidaEmData': 'Checked on {{data}}',
    'dp.rotinas.checklist.resumo': '{{conferidas}} checked, {{ressalvas}} with remarks and {{pendentes}} pending out of {{total}}',
    'dp.rotinas.checklist.periodo': 'From {{inicio}} to {{fim}}',
    'dp.rotinas.checklist.chave': 'Key {{chave}}',
    'dp.rotinas.checklist.inativo': 'Disabled item',
    'dp.rotinas.checklist.vazio': 'No items imported. Import the activity description spreadsheet.',
    'dp.rotinas.checklist.comoFunciona': 'Each payroll checklist item, by stage, with the check for the period. Remarks require a note. The key of each item is the one automation will use.',
    'dp.rotinas.importarTitulo': 'Import the activity description',
    'dp.rotinas.importarExplica': 'The HR activity description spreadsheet, with the routine detail sheet and the payroll checklist sheet. The catalog is updated by routine number and item key, without deleting what left the spreadsheet; a routine disabled in the Hub stays disabled.',
    'dp.rotinas.carga.rotinas': 'Routines in the spreadsheet',
    'dp.rotinas.carga.foraDoEscopo': 'Routines out of scope',
    'dp.rotinas.carga.prazoLivre': 'Routines without a date rule',
    'dp.rotinas.carga.itens': 'Checklist items',
    'dp.rotinas.carga.rotinasAusentes': 'Hub routines missing from the spreadsheet',
  },
  es: {
    'dp.rotinas.titulo': 'Rutinas de nómina',
    'dp.rotinas.aba.rotinas': 'Rutinas',
    'dp.rotinas.aba.checklist': 'Checklist de la nómina',
    'dp.rotinas.mes': 'Mes',
    'dp.rotinas.competencia': 'Período {{rotulo}}',
    'dp.rotinas.kpi.vencidas': 'Vencidas',
    'dp.rotinas.kpi.hoje': 'Vencen hoy',
    'dp.rotinas.kpi.proximas': 'Vencen en {{proximoDias}} días',
    'dp.rotinas.kpi.pendentes': 'Pendientes',
    'dp.rotinas.kpi.feitas': 'Hechas en el mes',
    'dp.rotinas.kpi.conferencias': 'Verificaciones pendientes',
    'dp.rotinas.col.rotina': 'Rutina',
    'dp.rotinas.col.escopo': 'Alcance',
    'dp.rotinas.col.prazo': 'Plazo',
    'dp.rotinas.col.dono': 'Responsable',
    'dp.rotinas.busca': 'Buscar actividad, responsable o número',
    'dp.rotinas.dono': 'Responsable',
    'dp.rotinas.todosDonos': 'Todos los responsables',
    'dp.rotinas.escopo': 'Alcance',
    'dp.rotinas.todosEscopos': 'Todos los alcances',
    'dp.rotinas.gerarMes': 'Generar mes',
    'dp.rotinas.mesGerado': '{{n}} ocurrencias creadas.',
    'dp.rotinas.mesNaoGerado': 'El mes aún no fue generado. Genérelo para ver las rutinas con la fecha límite de cada una.',
    'dp.rotinas.catalogo': 'Catálogo',
    'dp.rotinas.marcar': 'Marcar',
    'dp.rotinas.editarRotina': 'Corregir la rutina',
    'dp.rotinas.situacao.pendente': 'Pendiente',
    'dp.rotinas.situacao.feita': 'Hecha',
    'dp.rotinas.situacao.nao_se_aplica': 'No aplica',
    'dp.rotinas.feitaEm': 'Hecha el',
    'dp.rotinas.feitaEmData': 'Hecha el {{data}}',
    'dp.rotinas.marcarTitulo': 'Rutina {{numero}}',
    'dp.rotinas.prazo.dia_do_mes': 'Hasta el día {{n}}',
    'dp.rotinas.prazo.dia_util': '{{n}}º día hábil',
    'dp.rotinas.prazo.data_anual': 'Cada año el {{data}}',
    'dp.rotinas.prazo.livre': 'Sin fecha',
    'dp.rotinas.tipoPrazo': 'Regla del plazo',
    'dp.rotinas.tipoPrazo.dia_do_mes': 'Día del mes',
    'dp.rotinas.tipoPrazo.dia_util': 'Día hábil',
    'dp.rotinas.tipoPrazo.data_anual': 'Fecha del año',
    'dp.rotinas.tipoPrazo.livre': 'Libre, sin fecha',
    'dp.rotinas.prazoValor.dia': 'Día del mes, de 1 a 31',
    'dp.rotinas.prazoValor.enesimo': 'Enésimo día hábil',
    'dp.rotinas.prazoValor.data': 'Mes y día, como 01-15',
    'dp.rotinas.prazoTexto': 'Como lo escribe la planilla',
    'dp.rotinas.ativa': 'Activa',
    'dp.rotinas.inativa': 'Desactivada',
    'dp.rotinas.foraDoEscopo': 'Fuera del alcance',
    'dp.rotinas.pop': 'POP',
    'dp.rotinas.catalogoTitulo': 'Catálogo de rutinas',
    'dp.rotinas.catalogoExplica': 'Las rutinas de la planilla del DP, con las fuera del alcance y las desactivadas. Desactivar quita la rutina de los meses siguientes. Corregir el plazo rehace la fecha de las ocurrencias pendientes de este mes en adelante. La próxima importación de la planilla vuelve a valer sobre plazo y responsable.',
    'dp.rotinas.catalogo.filtro': 'Mostrar',
    'dp.rotinas.catalogo.todas': 'Todas',
    'dp.rotinas.catalogo.ativas': 'Activas',
    'dp.rotinas.catalogo.inativas': 'Desactivadas',
    'dp.rotinas.catalogo.foraDoEscopo': 'Fuera del alcance',
    'dp.rotinas.catalogo.busca': 'Buscar actividad o número',
    'dp.rotinas.catalogo.editar': 'Editar',
    'dp.rotinas.catalogo.contagem': '{{n}} de {{total}} rutinas',
    'dp.rotinas.rotinaTitulo': 'Rutina {{numero}}',
    'dp.rotinas.comoFunciona': 'Al comienzo del mes, Generar mes crea una ocurrencia por rutina activa dentro del alcance, con la fecha límite calculada del plazo de la rutina, los feriados del Hub y el sábado como día hábil. La rutina de plazo libre entra sin fecha. El checklist de la nómina usa el mismo mes como período.',
    'dp.rotinas.checklist.gerar': 'Generar verificaciones',
    'dp.rotinas.checklist.naoGerado': 'El período aún no tiene verificaciones. Genérelas para marcar ítem por ítem.',
    'dp.rotinas.checklist.gerado': '{{n}} verificaciones creadas.',
    'dp.rotinas.checklist.conferir': 'Verificar',
    'dp.rotinas.checklist.etapa.antes': 'Antes de correr la nómina',
    'dp.rotinas.checklist.etapa.na_folha': 'En la nómina',
    'dp.rotinas.checklist.etapa.depois': 'Después del pago',
    'dp.rotinas.checklist.situacao.pendente': 'Pendiente',
    'dp.rotinas.checklist.situacao.conferida': 'Verificada',
    'dp.rotinas.checklist.situacao.com_ressalva': 'Con observación',
    'dp.rotinas.checklist.conferidaEm': 'Verificada el',
    'dp.rotinas.checklist.conferidaEmData': 'Verificada el {{data}}',
    'dp.rotinas.checklist.resumo': '{{conferidas}} verificadas, {{ressalvas}} con observación y {{pendentes}} pendientes de {{total}}',
    'dp.rotinas.checklist.periodo': 'Del {{inicio}} al {{fim}}',
    'dp.rotinas.checklist.chave': 'Clave {{chave}}',
    'dp.rotinas.checklist.inativo': 'Ítem desactivado',
    'dp.rotinas.checklist.vazio': 'Ningún ítem importado. Importe la planilla de descripción de las actividades.',
    'dp.rotinas.checklist.comoFunciona': 'Cada ítem del checklist del cálculo de la nómina, por etapa, con la verificación del período. La observación es obligatoria con reparo. La clave de cada ítem es la que usará la automatización.',
    'dp.rotinas.importarTitulo': 'Importar la descripción de las actividades',
    'dp.rotinas.importarExplica': 'La planilla de descripción de las actividades del DP, con la hoja de detalle de rutinas y la hoja del checklist de la nómina. El catálogo se actualiza por el número de la rutina y por la clave del ítem, sin borrar lo que salió de la planilla; la rutina desactivada en el Hub sigue desactivada.',
    'dp.rotinas.carga.rotinas': 'Rutinas en la planilla',
    'dp.rotinas.carga.foraDoEscopo': 'Rutinas fuera del alcance',
    'dp.rotinas.carga.prazoLivre': 'Rutinas sin regla de fecha',
    'dp.rotinas.carga.itens': 'Ítems del checklist',
    'dp.rotinas.carga.rotinasAusentes': 'Rutinas del Hub ausentes de la planilla',
  },
}
